import { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { ReactComponent as Close } from "../../../../assets/svgIcon/listView/Close.svg";
import { ReactComponent as Search } from "../../../../assets/svgIcon/listView/search.svg";
import { PopupModal } from "../../../../components/TopBar/PopupModal/PopupModal";
import { FilterModalCss } from "./FilterModal";

export function SearchFilterModal({
  headerName,
  config,
  consignmentsParams = {},
  setConsignmentsParamsLocal,
  isAppliedFilter = {},
  setIsAppliedFilter,
  closeFilterModal,
  positionForFilter,
}) {
  const paramKey = config?.paramKey;
  const activeParamValue = useMemo(
    () => consignmentsParams?.[paramKey] || isAppliedFilter?.[headerName]?.value || "",
    [consignmentsParams, paramKey, isAppliedFilter, headerName],
  );
  const [searchQuery, setSearchQuery] = useState(activeParamValue);

  useEffect(() => {
    setSearchQuery(activeParamValue);
  }, [activeParamValue]);

  const toTitleCase = useMemo(() => {
    if (config?.label) return config.label;
    return headerName
      ?.split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }, [headerName, config?.label]);

  const handleSearch = () => {
    const trimmed = searchQuery.trim();
    if (trimmed) {
      setConsignmentsParamsLocal(state => ({
        ...state,
        [paramKey]: trimmed,
        offset: 0,
      }));
      setIsAppliedFilter(state => ({
        ...state,
        [headerName]: {
          isOpen: false,
          isApplied: true,
          paramKeys: [paramKey],
          value: trimmed,
        },
      }));
    } else {
      setConsignmentsParamsLocal(state => {
        const next = { ...state };
        delete next[paramKey];
        next.offset = 0;
        return next;
      });
      setIsAppliedFilter(state => ({
        ...state,
        [headerName]: {
          isOpen: false,
          isApplied: false,
          paramKeys: [],
          value: "",
        },
      }));
    }
    // closeFilterModal resets positionForFilter in addition to isOpen
    closeFilterModal();
  };

  const handleKeyDown = event => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSearch();
    }
  };

  const hasSearchValue = Boolean(searchQuery?.trim());

  return (
    <PopupModal styleOfModal={{ display: "contents" }} closeModal={closeFilterModal}>
      <FilterModalCss className="filterModal" style={positionForFilter}>
        <h3>
          Search {toTitleCase} <Close onClick={closeFilterModal} />
        </h3>

        <SearchInputContainerCss className="searchContainer">
          <input
            type="text"
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder={config?.placeholder || `Search ${toTitleCase}...`}
            autoFocus
          />
          <div className="searchIcon">
            <Search onClick={handleSearch} />
          </div>
        </SearchInputContainerCss>

        <div className="btnGrp">
          <button onClick={closeFilterModal} className="btnForModal">
            Cancel
          </button>
          <button
            className={
              hasSearchValue
                ? "btnForModal applyBtn activeBtn"
                : "btnForModal applyBtn"
            }
            onClick={handleSearch}
            disabled={!hasSearchValue}
          >
            Search
          </button>
        </div>
      </FilterModalCss>
    </PopupModal>
  );
}

export const SearchInputContainerCss = styled.div`
  margin: 19px 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #c5c7d0;
  border-radius: 4px;
  padding: 4px 8px 4px 12px;
  height: 24px;
  position: relative;
  background-color: #ffffff;

  &:focus-within {
    border-color: #2060ea;
  }

  > input {
    border: none;
    width: 100%;
    font-size: 12px;
    font-weight: 400;
    color: #0e0e2c;
    background: transparent;

    &::placeholder {
      color: #b9b9c6;
    }

    &:focus {
      outline: none;
      color: #0e0e2c;
    }
  }

  .searchIcon {
    width: 24px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      cursor: pointer;
    }
  }
`;
